import { render, staticRenderFns } from "./DeviationAction.vue?vue&type=template&id=0c95ccf7&"
import script from "./DeviationAction.vue?vue&type=script&lang=js&"
export * from "./DeviationAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports